import { NewsItem } from '@/redux/services/newsApi'
import Link from 'next/link'
import React from 'react'
import NewsDate from './NewsDate'
import { useRouter } from 'next/navigation'
import { setNewsFilterTags } from '@/redux/features/filterSlice'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import s from './NewsBanner.module.scss'

interface NewsSideItemProps {
    item: NewsItem
    lightTheme?: boolean
}

const NewsSideItem: React.FC<NewsSideItemProps> = ({ item, lightTheme }) => {
    const router = useRouter()
    const dispatch = useDispatch()

    const toNewsByTag = (id: number) => {
        dispatch(setNewsFilterTags([id]))
        router.push('/news')
    }

    return (
        <li className='news__banner-side-item'>
            <ul className='news__tags'>
                {item && item?.tags_id && item.tags_id.slice(0, 4)?.map(tag => (
                    <li
                        onClick={() => toNewsByTag(tag.id)}
                        key={tag.id}
                        className={classNames('news__tag', lightTheme ? s.linkColor : '')}
                    >
                        {tag.title}
                    </li>
                ))}
                <li className={classNames('news__tag-date', lightTheme ? s.dateColor : '')}>
                    <NewsDate date={item.creation_date} />
                </li>
            </ul>
            <Link
                href={`/news/${item.translit}`}
                className='news__banner-side-link'
            >
                <h2 className={classNames('news__title', lightTheme ? s.titleColor : '')}>{item.title}</h2>
            </Link>
        </li>
    )
}

export default NewsSideItem
